import i18n from 'i18next'
export const placeholder = () => ({
  email: 'mail@example.com',
  email_or_phone: i18n.t('placeholder.メールアドレスまたは電話番号'),
  clinic_name: i18n.t('placeholder.YaDocクリニック'),
  phone_number: '090-1234-5678',
  account_name_kana: i18n.t('placeholder.タナカ タロウ'),
  account_name: i18n.t('placeholder.田中 太郎'),
  last_name: i18n.t('placeholder.田中'),
  first_name: i18n.t('placeholder.太郎'),
  last_name_kana: i18n.t('placeholder.たなか'),
  first_name_kana: i18n.t('placeholder.たろう'),
  postal_code: '1030014',
  address: i18n.t('placeholder.東京都中央区日本橋蛎殻町1-27-5 YAMATO B.L.D'),
  prefecture: i18n.t('placeholder.東京都'),
  city: i18n.t('placeholder.中央区'),
  town: i18n.t('placeholder.蠣殻町'),
  street: '1-27-5',
  building: i18n.t('placeholder.YAMATO  B.L.D.'),
  credit_name: i18n.t('placeholder.YOKO SATO'),
  bank_name: i18n.t('placeholder.YaDoc銀行'),
  bank_number: '0001',
  branch_name: i18n.t('placeholder.蠣殻町支店'),
  branch_number: '001',
  partner_branch_name: i18n.t('placeholder.中央区支店'),
  account_number: '1234567',
})

export default placeholder
